<template>
  <div class="body">
    <van-nav-bar title="商品搜索" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content">
      <div class="searchtop">
        <div class="searchWrap">
          <i class="iconfont icon-sousuo"/>
          <input placeholder="请输入搜索关键词" v-model="value" @keyup.enter="search(value)">
        </div>
        <button @click="search(value)">搜索</button>
      </div>
      <div class="searchContent">
        <div class="searchTool">
          <p>最近搜索</p>
          <i class="iconfont icon-shanchu" @click="removeHistory()"/>
        </div>
        <div class="searchHistory">
          <p v-for="item in datalist" :key="item" @click="search(item)">{{item}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import { GetAddress } from "../../apis/https.js";
import {
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage
} from "../../utils/storage.js";
import { Search } from "vant";
import Vue from "vue";
Vue.use(Search);
export default {
  components: {
    NoData
  },
  data() {
    return {
      hasData: false,
      value: "",
      datalist: []
    };
  },
  created() {},
  activated() {
    let arr= getLocalStorage("search_history");
    arr != null ? this.datalist= arr : "" ;
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    search(value) {
      let arr = getLocalStorage("search_history");
      if (arr != null) {
        let i = 0;
        for (i; i < arr.length; i++) {
          if (arr[i] == value) {
            break;
          }
        }
        if (i == arr.length) {
          let arr2 = [value].concat(arr);
          setLocalStorage("search_history", arr2);
          arr2.length > 20 ? arr2.pop() : "";
        }
      } else {
        setLocalStorage("search_history", [value]);
      }
      this.$router.replace({
        path: "/pages/category/list",
        query: {
          searchName: value
        }
      });
    },
    removeHistory() {
      removeLocalStorage("search_history");
      this.datalist=[];
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content {
    margin-top: 46px;
    .searchtop {
      display: flex;
      padding: 10px;
      overflow: hidden;
      .searchWrap {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        flex: 1 1 auto;
        background: @white;
        display: flex;
        float: left;
        i {
          font-size: 20px;
          height: 32px;
          line-height: 32px;
          display: block;
          vertical-align: middle;
        }
        input {
          flex: 1 1 auto;
          border: 0px;
          background: @white;
          font-size: 14px;
          height: 30px;
          line-height: 30px;
          padding: 1px 0px;
        }
      }
      button {
        float: left;
        font-size: 14px;
        color: @white;
        background: @btn;
        border: 0px;
        width: 60px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        height: 32px;
        line-height: 32px;
      }
    }
    .searchContent {
      .searchTool {
        overflow: hidden;
        padding: 0px 10px;
        p {
          float: left;
          line-height: 30px;
          height: 30px;
          font-size: 14px;
        }
        i {
          float: right;
          line-height: 30px;
          height: 30px;
          width: 60px;
          text-align: right;
          font-size: 25px;
        }
      }
      .searchHistory {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        p {
          margin: 10px;
          width: 105px;
          font-size: 12px;
          text-align: center;
          border: 1px solid @lightP;
          border-radius: 4px;
          padding: 8px 0px;
          color: @lightP;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
}
</style>